import { render, staticRenderFns } from "./Kv.vue?vue&type=template&id=32aff49d&scoped=true&"
import script from "./Kv.vue?vue&type=script&lang=js&"
export * from "./Kv.vue?vue&type=script&lang=js&"
import style0 from "./Kv.vue?vue&type=style&index=0&id=32aff49d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aff49d",
  null
  
)

export default component.exports